/**
 * Spillguard API Doc
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type ChamberFloodStatus =
  | 'Unknown'
  | 'WaterIncreasing'
  | 'Flood'
  | 'WaterLowering';

export const ChamberFloodStatus = {
  Unknown: 'Unknown' as ChamberFloodStatus,
  WaterIncreasing: 'WaterIncreasing' as ChamberFloodStatus,
  Flood: 'Flood' as ChamberFloodStatus,
  WaterLowering: 'WaterLowering' as ChamberFloodStatus,
};
